import React from 'react';
import TestimonialsPage from '../../components/TestimonialsPage';

const Testimonials: React.FC = () => {
  return <TestimonialsPage />;
};

export default Testimonials;
